import { render, staticRenderFns } from "./PersonsReadOnlyPanel.vue?vue&type=template&id=1d2f998f"
import script from "./PersonsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./PersonsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports